<div class="col-md-12 col-xl-12 col-sm-12 col-xs-12 col-lg-4">
    <table class=" table-product" style="border-radius: 5px;">
        <thead class="table-head">
            <tr>
                <th scope="col" class="table-row text-center fs-12" style="padding-top: 10px; padding-left: 7px; padding-right: 7px; padding-bottom: 10px;">
                    Product
                </th>
                <th scope="col" class="table-row text-center fs-12" style="padding-top: 10px; padding-left: 7px; padding-right: 7px; padding-bottom: 10px;">
                    Currency
                </th>
                <th scope="col" class="table-row text-center fs-12" style="padding-top: 10px; padding-left: 7px; padding-right: 7px; padding-bottom: 10px;">
                    Fx Amount
                </th>
                <th scope="col" class="table-row text-center rate-header" style="padding-top: 10px; padding-left: 7px; padding-right: 7px; padding-bottom: 10px;">
                    Rate
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let singleItem of orderDetails?.orderItems">
                <td scope="col" class="table-col text-center fs-12" style="padding-top: 10px; padding-left: 7px; padding-right: 7px; padding-bottom: 10px; ">
                    {{singleItem?.product }}</td>
                <td scope="col" class="table-col text-center fs-12" style="padding-top: 10px; padding-left: 7px; padding-right: 7px; padding-bottom: 10px;">
                    {{singleItem?.currencyCode}}
                </td>
                <td scope="col" class="table-col text-center fs-12" style="padding-top: 10px; padding-left: 7px; padding-right: 7px; padding-bottom: 10px;">
                    {{singleItem?.currencyAmount}}
                </td>
                <td scope="col" class="table-col text-center rate-cell" style="padding-top: 10px; padding-left: 7px; padding-right: 7px; padding-bottom: 10px; word-break: break-all;">
                    {{singleItem?.ibrRate}}
                </td>
            </tr>
        </tbody>
    </table>
    <br>
    <div style="background: #f4f5f8;padding: 10px;border-radius: 5px;">
        <div class="invoice-sales-total-wrapper">
            <table class="table table-borderless  fs-12">
                <tbody>
                    <tr style="padding-top: 1px;">
                        <td class="thick-line text-black fw-600" colspan="3" style="padding-top: 1%;">
                            <strong>Amount :</strong>
                        </td>
                        <td class="thick-line text-right text-black fw-600 " style="padding-top: 1%;"> ₹ {{orderDetails?.invoice?.billableAmountString}}
                        </td>
                    </tr>
                    <!-- <tr style="padding-top: 1%;">
                        <td class="no-line " colspan="3" ><strong>Forex Margin :</strong></td>
                        <td class="no-line text-right">₹ {{forexMarginString}}</td>
                    </tr> -->
                    <tr style="padding-top: 1px;" *ngIf="orderDetails?.invoice?.totalHandlingChargesString != 0 && orderDetails?.invoice?.totalHandlingChargesString != 0.0">
                        <td class="no-line " colspan="3" style="padding-top: 1%;" *ngIf="orderDetails?.orderItems?.[0]?.product != 'REMITTANCE'">
                            <strong>Service Charges :
                            </strong>
                        </td>
                        <td class="no-line " colspan="3" *ngIf="orderDetails?.orderItems?.[0]?.product == 'REMITTANCE'"><strong>Fees & Charges</strong><br><span style="color: grey;" class="fs-10" >(Includes nostro & bank handling charges)</span></td>

                        <td *ngIf="!isSurrenderOrder" class="no-line text-right" style="padding-top: 1%;">₹ {{orderDetails?.invoice?.totalHandlingChargesString}}
                        <td *ngIf="isSurrenderOrder" class="no-line text-right" style="padding-top: 1%;">- ₹ {{orderDetails?.invoice?.totalHandlingChargesString}}

                        </td>
                    </tr>
                    <!-- <tr *ngIf="!isSurrenderOrder && !hideBeneficiaryDetails">
                        <td class="no-line " colspan="3" style="padding-top: 1%;">
                            <strong>Nostro Charges :
                            </strong>
                        </td>
                        <td class="no-line text-right" style="padding-top: 1%;">₹ {{orderDetails?.notstoChargesString}} </td>
                    </tr> -->
                    <tr>
                        <td class="no-line " colspan="3" style="padding-top: 1%;">
                            <strong> {{ orderDetails?.invoice?.xplorerCardDetails?.totalAmount && orderDetails?.invoice?.xplorerCardTotalBillableAmount != '0' ? 'Forex' : '' }} GST :</strong>
                        </td>
                        <td *ngIf="!isSurrenderOrder" class="no-line text-right" style="padding-top: 1%;">₹ {{orderDetails?.invoice?.totalTaxesString}}
                        <td *ngIf="isSurrenderOrder" class="no-line text-right" style="padding-top: 1%;">- ₹ {{orderDetails?.invoice?.totalTaxesString}}

                        </td>
                    </tr>
                     <tr *ngIf="orderDetails?.deliveryCharges!=0.0">
                        <td class="no-line " colspan="3" style="padding-top: 1%;">
                            <strong>Delivery Charges :</strong>
                        </td>
                        <td *ngIf="!isSurrenderOrder" class="no-line text-right" style="padding-top: 1%;">₹ {{orderDetails?.invoice?.deliveryCharges}}</td>
                         <td *ngIf="isSurrenderOrder" class="no-line text-right" style="padding-top: 1%;"> ₹ {{orderDetails?.invoice?.deliveryCharges}} </td>
                    </tr>

                    <tr *ngIf="orderDetails?.redeemedPoints!=0.0">
                        <td class="no-line " colspan="3" style="padding-top: 1%;">
                            <strong>Redeemed Points :</strong>
                        </td>
                        <td  class="no-line text-right" style="padding-top: 1%;">₹
                            {{orderDetails?.redeemedPoints}}
                
                    </tr>
                    <tr *ngIf="orderDetails?.invoice?.totalDiscount!=0.0">
                        <td class="no-line " colspan="3" style="padding-top: 1%;">
                            <strong>Coupon Code :</strong>
                        </td>
                        <td class="no-line text-right" style="padding-top: 1%;">₹
                            {{orderDetails?.invoice?.totalDiscount}}
                    
                    </tr>

                    <tr *ngIf="!isSurrenderOrder">
                        <td class="no-line " colspan="3" style="padding-top: 1%;">
                            <strong>TCS  ({{
                                orderDetails?.tcs?.tcsPercentageString1
                                }}%):</strong>
                        </td>
                        <td class="no-line text-right" style="padding-top: 1%;">₹ {{this.orderDetails?.tcs?.tcsAmountString1}}
                        </td>
                    </tr>

                    <!-- <tr style="border-top:1px solid #bdbcbc" *ngIf="orderDetails?.invoice?.xplorerCardDetails?.totalAmount && orderDetails?.invoice?.xplorerCardTotalBillableAmount != '0'">
                        <td class="no-line " colspan="3" style="padding-top: 1%;">
                            <strong style="font-weight: 800;">Total Forex Amount </strong>
                        </td>
                        <td class="no-line text-right" style="padding-top: 1%; font-weight: 800;">₹ {{ orderDetails?.invoice?.totalBillAmountString}}
                        </td>
                    </tr> -->
                    <!-- <tr *ngIf="!isSurrenderOrder">
                        <td class="no-line " colspan="3" style="padding-top: 1%;">
                            <strong>TCS 2 ({{
                                orderDetails?.tcs?.tcsPercentageString2
                                }}%):</strong>
                        </td>
                        <td class="no-line text-right" style="padding-top: 1%;">₹ {{this.orderDetails?.tcs?.tcsAmountString2}}
                        </td>
                    </tr> -->
                    <tr *ngIf="orderDetails?.invoice?.xplorerCardDetails && orderDetails?.invoice?.xplorerCardDetails?.kitFee">
                        <td class="no-line " colspan="3" style="padding-top: 1%;">
                            <strong>Kit Fees :</strong>
                        </td>
                        <td class="no-line text-right" style="padding-top: 1%;">
                            <strong>₹
                                {{ orderDetails?.invoice?.xplorerCardDetails?.kitFee }}</strong>
                        </td>
                    </tr>
                    <tr *ngIf="orderDetails?.invoice?.xplorerCardDetails && orderDetails?.invoice?.xplorerCardDetails?.kitFee">
                        <td class="no-line " colspan="3" style="padding-top: 1%;">
                            <strong>Kit GST :</strong>
                        </td>
                        <td class="no-line text-right" style="padding-top: 1%;">
                            <strong>₹
                                {{ orderDetails?.invoice?.xplorerCardDetails?.gst }}</strong>
                        </td>
                    </tr>
                    <tr style="border-top:1px solid #bdbcbc" *ngIf="orderDetails?.invoice?.xplorerCardDetails && orderDetails?.invoice?.xplorerCardDetails?.kitFee">
                        <td class="no-line " colspan="3" style="padding-top: 1%;">
                            <strong>Kit Total Amount :</strong>
                        </td>
                        <td class="no-line text-right" style="padding-top: 1%;">
                            <strong>₹
                                {{ orderDetails?.invoice?.xplorerCardDetails?.totalAmount }}</strong>
                        </td>
                    </tr>
                    <tr>
                        <td class="no-line " colspan="3" style="padding-top: 2%;">
                            <strong style="font-weight: 800;">Total Amount :</strong>
                        </td>
                        <td class="no-line text-right" style="padding-top: 2%; white-space: nowrap;">
                            <strong style="font-weight: 800;">
                                <ng-container *ngIf="orderDetails?.invoice?.xplorerCardDetails?.totalAmount && orderDetails?.invoice?.xplorerCardTotalBillableAmount != '0'">₹ {{orderDetails?.invoice?.xplorerCardTotalBillableAmount}}</ng-container>
                                <ng-container *ngIf="!(orderDetails?.invoice?.xplorerCardDetails?.totalAmount && orderDetails?.invoice?.xplorerCardTotalBillableAmount != '0')">₹ {{orderDetails?.invoice?.totalBillAmountString}}</ng-container>
                            </strong>
                        </td>
                    </tr>
                    <tr>
                        <td class="no-line " colspan="3" style="padding-top: 1%;" *ngIf="!isSurrenderOrder">
                            <strong>Amount Paid :</strong>
                        </td>
                        <td class="no-line " colspan="3" style="padding-top: 1%;" *ngIf="isSurrenderOrder" >
                            <strong>Payment Issued :</strong>
                        </td>
        
                        <td class="no-line text-right" style="padding-top: 1%;">
                            <strong>₹
                                {{orderDetails?.invoice?.totalPaymentReceivedString}}</strong>
                        </td>
                    </tr>
                    <tr>
                        <td class="no-line fw-800" colspan="3" style="color: #1d2a62; padding-top: 0%;">
                            Balance : </td>
                        <td class="no-line text-right fw-800" style="color: #1d2a62; padding-top: 0%; white-space: nowrap;"> ₹ {{this.orderDetails?.invoice?.totalPaymentPendingString}}
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
    <br>
</div>